<script lang="ts">
  import type { FormField } from '../types';
  import { resetField } from '$lib/helpers/form-field-reset';

  export let field: FormField;
  export let inputValue: string = field.autofillValue || '';
  export let isError: boolean = false;

  let inputTextElement: HTMLInputElement;

  const handleClick = () => {
    inputTextElement.focus();
  };
</script>

<div class="marketInput" class:isError on:click={handleClick} role="textbox">
  <input
    bind:this={inputTextElement}
    bind:value={inputValue}
    type="text"
    placeholder={field.placeholder || ' '}
    id={field.id}
    name={field.id}
    autocomplete={field.autocompleteType}
    required={field.required}
    use:resetField
  />
  {#if field.label}
    <label for={field.id}>{field.label || field.placeholder}</label>
  {/if}
</div>

<style lang="scss">
  .marketInput {
    min-height: var(--field-input-height);
    flex-flow: column-reverse;

    label {
      bottom: 4px;
      position: relative;
      padding-right: var(--space-30);
    }
  }
</style>
